import React, { useState, useEffect } from "react"
import FormPopup from "./FormPopup";

//test
//https://api.telegram.org/bot7229815824:AAFd3AGDotsDsiuoU3qzJl6ezXk6WRVeF9w/sendMessage
//-4685858033

type props = {
    note?: string;
    head?: { title?: string, description?: string };
    children: any;
}

const ApplicationPopup = ({ note, head, children }: props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [fields, setFields] = useState([
        { name: "fio", title: "Фио", require: true },
        { name: "pHOneQEWQ", title: "Телефон", require: true },
        { name: "email", title: "Ваша почта", require: true },
        { name: "comment", title: "Комментарий", element: "textarea", require: true },
        {
            name: "agreement",
            title: "Я прочитал(а) и согласен(на) с Политикой обработки персональных данных",
            element: "checkbox",
            require: true
        }
    ])

    return (
        <>
            <div onClick={() => setIsOpen(true)}>{children}</div>

            <FormPopup
                fields={fields}
                isOpen={isOpen}
                close={() => setIsOpen(false)}
                head={{ title: head?.title || "Оставьте заявку", description: head?.description || "Оставьте заявку и наш сотрудник свяжется с вами" }}
                url={"https://api.telegram.org/bot7649938106:AAGCziBiX53uAgJx6Va84EbzX6z5MrV-Zt4/sendMessage"}
                chatId={-4166037569}
                noteText={note}
            />
        </>
    )
}

export default ApplicationPopup;